import {
  MY_REPORTS_PATH,
  QUESTIONNAIRES_PATH,
} from '@/constants/paths';

import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { useGetInitData } from '@viome/viome-base/src/usecase/Bootup/BootupQuery';
import { useGetFeatureKeys } from '@viome/viome-base/src/usecase/Misc/MiscQuery';

export type SettingsPageHealthProfileSectionProps = React.ComponentProps<'div'> & {
  'data-testid'?: string;
};

export const SettingsPageHealthProfileSection = ({
  className,
  'data-testid': testId,
}: SettingsPageHealthProfileSectionProps) => {

  const { data: initData } = useGetInitData();
  const { data: featureKeys } = useGetFeatureKeys();

  const hasRecommendation = initData?.lockstatus?.hasRecommendation;
  const isPdfShareEnabled = featureKeys?.is_pdf_share_enabled;

  const shouldShowForm = hasRecommendation && isPdfShareEnabled;

  return (
    <div className={cn('flex flex-col', className)} data-testid={testId}>
      <span className="typography-h2 text-primary mb-6" data-testid="settingsHealthProfile-title">Health Profile</span>

      <Card data-testid="settingsHealthProfile-card">
        <List data-testid="settingsHealthProfile-list">
          <ListItem asChild data-testid="settingsHealthProfile-questionnaireItem">
            <Link to={QUESTIONNAIRES_PATH}>My Questionnaire</Link>
          </ListItem>

          {shouldShowForm && (
            <ListItem asChild data-testid="settingsHealthProfile-reportsItem">
              <Link to={MY_REPORTS_PATH}>Send Reports in PDF</Link>
            </ListItem>
          )}
        </List>
      </Card>
    </div>
  );
};
